/**
 * Statuts et méthodes liés à l'authentification et aux sessions.
 * Référence : document 04 § 5.1 et § 5.2 — contraintes `CHECK` correspondantes.
 */
export const USER_STATUSES = ['active', 'suspended', 'disabled'];
export const THEME_PREFERENCES = ['light', 'dark', 'system'];
export const MEMBERSHIP_STATUSES = ['invited', 'active', 'suspended', 'revoked'];
export const SESSION_REVOKE_REASONS = [
    'logout',
    'rotation_reuse',
    'admin',
    'password_change',
];
export const LOGIN_RESULTS = [
    'success',
    'bad_password',
    'mfa_failed',
    'locked',
    'unknown_user',
];
export const MFA_METHODS = ['totp'];
export const INVITATION_STATUSES = ['pending', 'accepted', 'expired', 'revoked'];
export const AUDIT_ACTOR_TYPES = ['user', 'portal_user', 'system', 'webhook'];
export const AUDIT_SEVERITIES = ['info', 'warning', 'critical'];
/** Motifs d'échec renvoyés au client sous forme de codes d'erreur stables (document 06 § 2.5). */
export const AUTH_ERROR_CODES = {
    invalidCredentials: 'AUTH_INVALID_CREDENTIALS',
    emailNotVerified: 'AUTH_EMAIL_NOT_VERIFIED',
    accountLocked: 'AUTH_ACCOUNT_LOCKED',
    tokenExpired: 'AUTH_TOKEN_EXPIRED',
    refreshReuse: 'AUTH_REFRESH_REUSE',
    permissionDenied: 'AUTHZ_PERMISSION_DENIED',
};
//# sourceMappingURL=auth.enum.js.map